let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'SharedService',
    '$stateParams',
    '$uibModal',
    'Pagination',
    'ngAuthSettings',
    '$timeout',
    'ProcedureListService'
];

class ProcedureListController {

    constructor($scope, $state, $rootScope, SharedService, $stateParams, $uibModal, Pagination, ngAuthSettings, $timeout,
                ProcedureListService) {
        this.$state = $state;
        this.$scope = $scope;
        this.ngAuthSettings = ngAuthSettings;
        this.Pagination = Pagination;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.SharedService = SharedService;
        this.$timeout = $timeout;
        this.loanding = false;
        this.procedures = [];
        this.procedureService = ProcedureListService;
        this.procedureSlug = this.$stateParams.procedureSlug || '';

        this.pageName = "PAG-18";

        this.SharedService.getCMSBanners(this.pageName).then(response => {
            this.cmsData = response;
            this.shCtrl.setTags(this.cmsData.seo);
        });
    }

    $onInit() {
        this.procedureService.getProceduresData(this.procedureSlug).then(response => {

            this.procedures = response;
            this.tittle=Object.keys(this.procedures)[0];

            /*angular.forEach(response,  (value, key) => {
                this.procedures.push({key : value});
            });
            console.log(this.procedures);*/

        }).catch(error => {});
    }

}

ProcedureListController.$inject = inject;

export default ProcedureListController;




/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/catalog/procedure-list/procedure-list.controller.js
 **/